import React from 'react';

import { BORDER, cell, WEEK_H } from '../shared/style';

export default function WeekHeaderCell({ wg }) {
  return (
    <div
      style={cell({
        gridColumn: `span ${wg.count}`,
        fontSize: 9,
        color: '#aaa',
        borderRight: BORDER,
        borderBottom: BORDER,
        background: '#fff',
        display: 'flex',
        alignItems: 'center',
        borderLeft: '2px solid #e5e3de',
        paddingLeft: 5,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        height: WEEK_H,
      })}
    >
      S{wg.week}
    </div>
  );
}
